module.exports = __webpack_public_path__ + "static/media/fire.e0e0b179.png";